var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutleryAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22103 5.33841C2.97158 5.08823 2.53342 5.12204 2.24238 5.4139C1.95135 5.70577 1.91764 6.14518 2.1671 6.39535L5.93115 10.1701C6.91331 11.1551 8.41033 11.3091 9.55345 10.632L19.8027 20.9106C20.0937 21.2025 20.5656 21.2025 20.8566 20.9106C21.1476 20.6188 21.1476 20.1456 20.8566 19.8537L10.6074 9.57513C11.2826 8.42872 11.1291 6.92737 10.1469 5.94237L6.38283 2.16758C6.13337 1.91741 5.69522 1.95121 5.40418 2.24307C5.11315 2.53494 5.07944 2.97435 5.3289 3.22452L9.09295 6.99931L8.56595 7.52781L5.05301 4.00478C4.76198 3.71292 4.29011 3.71291 3.99908 4.00478C3.70804 4.29664 3.70803 4.76985 3.99907 5.06172L7.51202 8.58476L6.98508 9.1132L3.22103 5.33841Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.742 14.9408L9.19647 12.388C9.09785 12.4144 8.9985 12.4374 8.89862 12.457C8.86377 12.7485 8.95658 13.0541 9.18254 13.2807L10.1657 14.2666L3.78693 20.6635C3.49589 20.9554 3.51165 21.4444 3.82213 21.7557C4.13261 22.0671 4.62023 22.0829 4.91127 21.791L11.742 14.9408Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.904 11.7702L12.3664 9.22535L19.9065 2.97162C20.302 2.65936 20.8679 2.69301 21.2238 3.04996L21.709 3.53652C22.097 3.92568 22.097 4.55663 21.709 4.94578L14.904 11.7702Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutleryAlt1);
export default __webpack_public_path__ + "static/media/cutlery-alt-1.3ddc464d0a8995fad21add1679782e8a.svg";
export { ForwardRef as ReactComponent };